import { type FC } from "react";
import { connect } from "react-redux";
import { type MessageData } from "~/features/toasts/redux/types";
import ToastMessage from "~/common/components/Messages/ToastMessage/ToastMessage";
import { type Dispatch } from "redux";
import { dismissMessage } from "~/features/toasts/redux/actions";
import { type RootState } from "~/app/store";
import { Translation } from "~/app/i18n/Translation";

interface GlobalMessageProps {
  messages: MessageData[];
  removeMessage: (id: number) => void;
}

// @ts-ignore
const GlobalMessage: FC<GlobalMessageProps> = ({ messages, removeMessage }) => {
  if (messages.length === 0) {
    return null;
  }

  return messages.map((msg) => {
    return (
      <ToastMessage key={msg.id} type={msg.severity} onClose={() => removeMessage(msg.id)}>
        <Translation {...msg.message} />
      </ToastMessage>
    );
  });
};

const mapStateToProps = (state: RootState) => {
  return {
    messages: state.globalMessages,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  removeMessage: (id: number) => dispatch(dismissMessage(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMessage);
